import React from 'react';
/* eslint-disable */
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
/* eslint-enable */
import {
  configApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import {
  makeFieldSchemaFromZod,
  scaffolderPlugin,
} from '@backstage/plugin-scaffolder';
import { Checkbox, TextField } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@material-ui/lab/Autocomplete'; // eslint-disable-line
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Chip, Typography } from '@mui/material';
import axios, { HttpStatusCode } from 'axios'; // eslint-disable-line
import { useAsync } from 'react-use';
// zod/v3: makeFieldSchemaFromZod is typed against zod's v3 ZodType, whose generics
// differ from v4's. The root zod is v4.
import { z } from 'zod/v3'; // eslint-disable-line
import { GithubTeam } from './GithubTeams';

const GithubTeamsSchema = makeFieldSchemaFromZod(
  z.object({
    teamSlugs: z.string().array(),
  }),
  z.object({}),
);

type GithubTeamsSchemaProps = typeof GithubTeamsSchema.type;
const GithubTeamsSchemaSchema = GithubTeamsSchema.schema;

const GithubTeamsMultiSelect = ({ onChange, schema, uiSchema, name, formData }: GithubTeamsSchemaProps) => {
  const title = schema.title || name || 'GitHub Teams';
  // When false, the owner team is not forced into the selection
  const lockSelectedTeam = uiSchema?.['ui:options']?.lockSelectedTeam !== false;
  const configApi = useApi(configApiRef);
  const identityApi = useApi(identityApiRef);
  const baseURL = `${configApi.getString(
    'backend.baseUrl',
  )}/api/proxy/api-github`;
  const { value: githubTeams, loading, error } = useAsync(async () => {
    const { token } = await identityApi.getCredentials();
    const response = await axios({
      url: `${baseURL}/orgs/TRANZACT/teams?per_page=100`,
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response && response.status !== HttpStatusCode.Ok) {
      throw new Error('Failed to fetch GitHub teams');
    }
    return await response.data as GithubTeam[];
  }, []);

  if (error) return <Typography color={'red'} variant='subtitle1'>error: {error.message}</Typography>;
  if (!githubTeams) return <div>no data</div>;

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const selectedTeamJson = localStorage.getItem('githubTeamsField:selectedTeam');
  // if (selectedTeamJson) localStorage.removeItem('githubTeamsField:selectedTeam');
  const userTeam: GithubTeam = JSON.parse(selectedTeamJson || '{}');
  const fixedTeams = lockSelectedTeam ? githubTeams.filter(team => team.slug === userTeam.slug) : [];

  const selectedTeams = [
    ...fixedTeams,
    ...formData?.teamSlugs ? githubTeams.filter(team => formData.teamSlugs.includes(team.slug) && !fixedTeams.map(e => e.slug).includes(team.slug)) : []
  ];

  onChange({ teamSlugs: selectedTeams.map(team => team.slug) });

  return (
    <FormControl>
      <Autocomplete
        multiple
        loading={loading}
        options={githubTeams}
        getOptionLabel={(team: GithubTeam) => team.name}
        value={selectedTeams}
        renderInput={params => (
          <TextField
            {...params}
            label={title}
            variant="outlined"
            InputProps={{
              ...params.InputProps,
            }}
          />
        )}
        renderOption={(option, { selected }) => (
          <React.Fragment>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option.name}
          </React.Fragment>
        )}
        renderTags={(tagValue, getTagProps) =>
          tagValue.map((option, index) => (
            <Chip
              label={option.name}
              {...getTagProps({ index })}
              disabled={fixedTeams.indexOf(option) !== -1}
            />
          ))
        }
        onChange={(_, teams: GithubTeam[] | null) => {
          console.log(teams);
          if (!teams) {
            onChange(undefined);
            return;
          }
          const selectedTeams = [...fixedTeams, ...teams.filter(team => !fixedTeams.includes(team))];
          onChange({
            teamSlugs: selectedTeams.map(team => team.slug),
          });
        }}
      />
    </FormControl>
  );
};

export const GithubTeamsMultiselectExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GithubTeamsMultiSelect',
    component: GithubTeamsMultiSelect,
    schema: GithubTeamsSchemaSchema,
  }),
);
